import type { MPLOffer, MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import { isMplOffer, isMplPreApprovalOffer } from 'shared/lib';
import type { TOffer } from 'shared/types/TRankingService';

export const getAnalyticsProductTypeParam = (offer: TOffer | MPLOffer | MPLPreApprovalOffer) => {
  if (isMplOffer(offer) || isMplPreApprovalOffer(offer)) {
    return offer.productType;
  }

  return offer.category || '';
};
